import React from "react";

import { CircularProgress, makeStyles, Typography } from "@material-ui/core";

import ResolutionPicker from "../ResolutionPicker";
import { WebTrackerResolution, WebTrackerResolutionType } from "../../types";
import { User, userDisplayName } from "../../../components/users/types";

const useStyles = makeStyles((theme) => ({
  loaderWrapper: {
    position: "relative",
    width: "100%",
    minHeight: "100px",
  },
  loader: {
    left: "50%",
    position: "absolute",
    top: "50%",
    transform: "translateX(-50%) translateY(-50%)",
  },
  notesAuthor: {
    padding: theme.spacing(2, 1),
    marginBottom: theme.spacing(2),
  },
}));

type TrackerResolutionContentProps = {
  isEditing: boolean;
  isLoading: boolean;
  webTrackerResolution?: WebTrackerResolution;
  user?: User;
  onChange: (value: WebTrackerResolutionType) => void;
  disableBAA: boolean;
  trackerName: string;
};

function TrackerResolutionContent({
  isEditing,
  isLoading,
  webTrackerResolution,
  user,
  onChange,
  disableBAA,
  trackerName,
}: TrackerResolutionContentProps) {
  const classes = useStyles();

  if (isEditing || isLoading) {
    return (
      <div className={classes.loaderWrapper}>
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  if (webTrackerResolution !== undefined) {
    return (
      <>
        <ResolutionPicker
          value={webTrackerResolution.resolutionType}
          onChange={onChange}
          disableBAA={disableBAA}
          trackerName={trackerName}
        />
        {user !== undefined && (
          <Typography className={classes.notesAuthor} variant="caption">
            Last updated by {userDisplayName(user)}
            {", "}
            {webTrackerResolution.updatedAt.toLocaleString()}
          </Typography>
        )}
      </>
    );
  }

  return (
    <ResolutionPicker
      value="unresolved"
      onChange={onChange}
      disableBAA={disableBAA}
      trackerName={trackerName}
    />
  );
}

export default TrackerResolutionContent;
